module.exports = __webpack_public_path__ + "img/126.0f86d86d.jpg";